"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jsxFileName = "/Users/tylerbarnes/Sites/gatsby-plugin-transition-link/src/wrap-page.js";

var React = require("react");

var TransitionHandler = require("./components/TransitionHandler").default;

var InternalProvider = require("./context/InternalProvider").default;

var Consumer = require("./context/createTransitionContext").Consumer; // eslint-disable-next-line react/prop-types,react/display-name


module.exports = function (_ref) {
  var element = _ref.element,
      props = _ref.props;
  var sessionMinHeight = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("wrapperMinHeight") : false;
  return React.createElement(InternalProvider, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }, React.createElement(Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }, function (_ref2) {
    var wrapperMinHeight = _ref2.wrapperMinHeight,
        inTransition = _ref2.inTransition;
    var minHeight = wrapperMinHeight ? wrapperMinHeight + "px" : "" + (!!sessionMinHeight ? sessionMinHeight + "px" : false);
    return React.createElement("div", {
      style: {
        position: "relative",
        zIndex: 0,
        minHeight: inTransition ? false : minHeight
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      },
      __self: this
    }, React.createElement(TransitionHandler, (0, _extends2.default)({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      },
      __self: this
    }), element));
  }));
};